<div id="pagConfig" class="page-layout simple">

  <!-- HEADER -->
  <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

    <div class="hero-text" fxLayout="row" fxLayoutAlign="start center">
      <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">person_add</mat-icon> -->
      <button mat-icon-button class="mr-16" *ngIf="tipoSeleccionado && !menuProductosNuevosAmco" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button mat-icon-button class="mr-16" *ngIf="tipoSeleccionado && menuProductosNuevosAmco && !flechaAtras2" (click)="goBack1()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button mat-icon-button class="mr-16" *ngIf="tipoSeleccionado && menuProductosNuevosAmco && tipoSeleccionadoNuevoProducto" (click)="goBack2()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
        {{'RESULTADOS.TITULO' | translate}}
      </h1>
    </div>

  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="content p-24" >

    <div fxLayout="column" fxLayoutAlign="center center">

      <div class="courses" fxLayout="row wrap" fxLayoutAlign="center center" [@animateStagger]="{value:'50'}">

        <!--- lista de tipos de productos --->
        <ng-container *ngIf="!tipoSeleccionado">
          <div class="course" *ngFor="let funcion of funciones" fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-sm="33" [ngClass]="funcion.category" [@animate]="{value:'*',params:{y:'100%'}}">
            <ng-container *ngIf="funcion.visible">
              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

                <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                  <div class="category" fxFlex>
                    {{'RESULTADOS.SECCIONES.'+funcion.id+'.TITULO' | translate}}
                  </div>
                  <!-- <div class="category" fxFlex>
                    {{'RESULTADOS.SECCIONES.'+funcion.id+'.TITULO' | translate}} {{'RESULTADOS.SECCIONES.TITULO_VER' | translate}} {{tableauVersion}}
                  </div> -->
                </div>

                <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                  <!-- <div class="h1">{{funcion.title}}</div>
                  <div class="updated">Updated {{funcion.updated}}</div> -->
                  <!-- <mat-icon class="length-icon s-120">{{funcion.icon}}</mat-icon> -->
                  <img src="assets/images/logos/{{funcion.imagen}}.png" alt="">
                </div>
                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                  <!-- <button mat-button color="accent" [routerLink]="'/results/trust_index/'+funcion.slug+'/'">
                  {{'RESULTADOS.SECCIONES.'+funcion.id+'.BOTON' | translate}}
                </button> -->
                <button *ngIf="flagResults.length>0"mat-button color="accent" (click)="obtieneProductos(funcion.tipo)" [disabled]="flagResults[0].flag">
                  {{'RESULTADOS.SECCIONES.'+funcion.id+'.BOTON' | translate}}
                </button>
                <!-- <button mat-button color="accent" (click)="Tableau()">
                {{'RESULTADOS.SECCIONES.'+funcion.id+'.BOTON' | translate}}
              </button> -->
            </div>

          </div>
        </ng-container>

      </div>
        </ng-container>


    <!--- lista de productos adquiridos --->
    <ng-container *ngIf="tipoSeleccionado && !menuProductosNuevosAmco">
      <ng-container *ngIf="cargando">
        <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
          </div>
        </div>
      </ng-container>
      <!-- RESULTADOS -->
      <ng-container *ngIf="!cargando">
        <mat-tab-group style="width:100%">
          <mat-tab label="{{tituloResultado | translate}} ">
            <div class="" fxLayout="row wrap" fxFlex="100">
              <div *ngIf="productosAsignados.length == 0 && productosLegacy.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>
              <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{producto.tagStatus | translate}}</div>

                      <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1" *ngIf="producto.idProducto!=42">{{producto.title | translate}}   </div>
                      <div class="h1" *ngIf="producto.idProducto==42">{{producto.title | translate}} </div>
                      <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div>
                      <div class="textFechaCierre">{{producto.fechaCierre|date:'d MMM y':offsetPipe:idiomaActual}}</div>
                      <div class="textToken">{{producto.tokenEncuesta}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">

                      <button *ngIf="producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/trust_index/'+producto.url,producto.productoID,producto.tableauVersion,producto,producto.idProducto);">{{producto.start | translate}}</button>
                      <button *ngIf="!producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="mensajeSwal('RESULTADOS.VALIDANDO.MENSAJE',2)">{{'RESULTADOS.VALIDANDO.BOTON' | translate}}</button>
                    </div>



                  </div>
                </div>

              </div>

              <!--legacy results-->
              <!-- <div *ngFor="let producto of productosLegacy; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{producto.tagStatus | translate}} {{tableauVersion}}</div>

                      <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1">{{producto.title | translate}} {{producto.numeroPul}} </div>
                      <div class="updated">{{'WIZARD.LANDING.LEGA' | translate}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/legacy',producto.productoID);">{{producto.start | translate}}</button>
                    </div>
                  </div>
                </div>

              </div> -->

            </div>
          </mat-tab>
          <mat-tab label="{{'RESULTADOS.TABPRIN.TAB4ALL' | translate}}" *ngIf="tipoSeleccionado == '1' && idInstituto ==1 || idInstituto==11 && !validarIzzi || tipoSeleccionado == '1' && idInstituto==2">
            <div class="" fxLayout="row wrap" style=" width:100%;">
              <div *ngIf="productosAsignados.length == 0 && productosLegacy.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>
              <ng-container *ngIf="!sinCertificar">
                <div *ngFor="let producto of productosAsignadosCertificar; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                  <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                      <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                        <div class="category" fxFlex>{{'RESULTADOS.TABPRIN.TITURES' | translate}}</div>

                        <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                          <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                        </div>
                      </div>

                      <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                        <div class="h1">{{producto.title | translate}}</div>

                        <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div>
                      </div>

                      <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                        <button *ngIf="producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="navigateToForAllNuevo('/results/4all/',producto.productoID,'',producto);">{{producto.start | translate}}</button>
                        <button *ngIf="!producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="mensajeSwal('RESULTADOS.VALIDANDO.MENSAJE',2)">{{'RESULTADOS.VALIDANDO.BOTON' | translate}}</button>
                      </div>
                      <button  mat-button class="accent rndBt" fxFlex="100" matTooltip="por programar"
                      (click)="copyMessage(producto)">{{'CONFING_RESUL.EXTERNAL_PORTAL' | translate}}</button>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Empieza forall resultados viejos -->
              <div class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" *ngIf="productosAsignadosCertificar.length != 0 && idInstituto!=2 || productosLegacy.length != 0 && idInstituto!=2">
                <div class="cursoCard" fxFlex="100" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 ">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{'RESULTADOS.4ALLVIEJAS.TITULO' | translate}}</div>
                      <div class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1">{{'RESULTADOS.4ALLVIEJAS.TITULOCERTIFICAR' | translate}}</div>
                      <div class="updated">{{'RESULTADOS.4ALLVIEJAS.APLICACIONANIO' | translate}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/forallviejos');">{{'RESULTADOS.4ALLVIEJAS.BOTON' | translate}}</button>
                    </div>

                  </div>

                </div>
              </div>
              <!-- Termina forall resultados viejos -->

            </div>
          </mat-tab>

        </mat-tab-group>








      </ng-container>
    </ng-container>

    <ng-container *ngIf="menuProductosNuevosAmco">
    <ng-container *ngIf="!tipoSeleccionadoNuevoProducto">
      <div class="course" *ngFor="let funcion of productosNuevos" fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-sm="33" [ngClass]="funcion.category" [@animate]="{value:'*',params:{y:'100%'}}">
        <ng-container *ngIf="funcion.visible">
          <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

            <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
              <div class="category" fxFlex>
                {{'RESULTADOS.SECCIONES.'+funcion.id+'.TITULO' | translate}}
              </div>
            </div>

            <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
              <img src="assets/images/logos/{{funcion.imagen}}.png" alt="">
            </div>
            <div class="footer" fxLayout="row" fxLayoutAlign="center center">

            <button mat-button color="accent" (click)="obtieneProductosProductoAmco(funcion.tipo)" [disabled]="flagResults[0].flag">
              {{'RESULTADOS.SECCIONES.'+funcion.id+'.BOTON' | translate}}
            </button>
        </div>

      </div>
    </ng-container>

  </div>
    </ng-container >

    <ng-container *ngIf="tipoSeleccionadoNuevoProducto">
      <ng-container *ngIf="cargandoNuevos">
        <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
          </div>
        </div>
      </ng-container>
      <!-- RESULTADOS -->
      <ng-container *ngIf="!cargandoNuevos">
        <mat-tab-group style="width:100%">
          <mat-tab label="{{tituloResultado2 | translate}} ">
            <div class="" fxLayout="row wrap" fxFlex="100">
              <div *ngIf="productosAsignados.length == 0 && productosLegacy.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>
              <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{producto.tagStatus | translate}}</div>

                      <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1" *ngIf="producto.idProducto!=42">{{producto.title | translate}}   </div>
                      <div class="h1" *ngIf="producto.idProducto==42">{{producto.title | translate}} </div>
                      <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">

                      <button *ngIf="producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/trust_index/'+producto.url,producto.productoID,producto.tableauVersion,'',producto.idProducto);">{{producto.start | translate}}</button>
                      <button *ngIf="!producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="mensajeSwal('RESULTADOS.VALIDANDO.MENSAJE',2)">{{'RESULTADOS.VALIDANDO.BOTON' | translate}}</button>
                    </div>



                  </div>
                </div>

              </div>

              <!--legacy results-->
              <!-- <div *ngFor="let producto of productosLegacy; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{producto.tagStatus | translate}} {{tableauVersion}}</div>

                      <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1">{{producto.title | translate}} {{producto.numeroPul}} </div>
                      <div class="updated">{{'WIZARD.LANDING.LEGA' | translate}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/legacy',producto.productoID);">{{producto.start | translate}}</button>
                    </div>
                  </div>
                </div>

              </div> -->

            </div>
          </mat-tab>
          <mat-tab label="{{'RESULTADOS.TABPRIN.TAB4ALL' | translate}}" *ngIf="tipoSeleccionado == '1' && idInstituto==1 || idInstituto==11 && !validarIzzi">
            <div class="" fxLayout="row wrap" style=" width:100%;">
              <div *ngIf="productosAsignados.length == 0 && productosLegacy.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>
              <ng-container *ngIf="!sinCertificar">
                <div *ngFor="let producto of productosAsignadosCertificar; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                  <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                      <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                        <div class="category" fxFlex>{{'RESULTADOS.TABPRIN.TITURES' | translate}}</div>

                        <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                          <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                        </div>
                      </div>

                      <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                        <div class="h1">{{producto.title | translate}}</div>

                        <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div>
                      </div>

                      <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                        <button *ngIf="producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/4all/',producto.productoID,'',producto);">{{producto.start | translate}}</button>
                        <button *ngIf="!producto.activo" mat-button class="accent rndBt" fxFlex="100" (click)="mensajeSwal('RESULTADOS.VALIDANDO.MENSAJE',2)">{{'RESULTADOS.VALIDANDO.BOTON' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Empieza forall resultados viejos -->
              <div class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" *ngIf="productosAsignados.length != 0 || productosLegacy.length != 0">
                <div class="cursoCard" fxFlex="100" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>{{'RESULTADOS.4ALLVIEJAS.TITULO' | translate}}</div>

                      <div class="length" fxLayout="row" fxLayoutAlign="end center">
                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1">{{'RESULTADOS.4ALLVIEJAS.TITULOCERTIFICAR' | translate}}</div>
                      <div class="updated">{{'RESULTADOS.4ALLVIEJAS.APLICACIONANIO' | translate}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/results/forallviejos');">{{'RESULTADOS.4ALLVIEJAS.BOTON' | translate}}</button>
                    </div>

                  </div>

                </div>
              </div>
              <!-- Termina forall resultados viejos -->

            </div>
          </mat-tab>

        </mat-tab-group>
      </ng-container>
    </ng-container>

    </ng-container>

    <div class="no-courses" *ngIf="funciones.length === 0">
      <h1>{{'RESULTADOS.SECCIONES.NOSECCIONES' | translate}}</h1>
    </div>

  </div>

</div>

</div>
<!-- / CONTENT -->

</div>
